//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _AppConfigurationClient {

    

            getConfiguration(showSpinner = true): Promise<OM.AppConfiguration> {
                        return CommonServices.defaultGet<OM.AppConfiguration>(apiurl + 'api/AppConfiguration/GetConfiguration',{  }, showSpinner);

                    }
    

            save(
                item:OM.AppConfiguration,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/AppConfiguration/Save', item,{}, showSpinner );

                    }
    

            sendTestMail(
                recipient:string,showSpinner = true): Promise<OM.AppConfiguration> {
                        return CommonServices.defaultGet<OM.AppConfiguration>(apiurl + 'api/AppConfiguration/SendTestMail',{ recipient }, showSpinner);

                    }
    

            getPrivacyPolicy(showSpinner = true): Promise<OM.Attachment> {
                        return CommonServices.defaultGet<OM.Attachment>(apiurl + 'api/AppConfiguration/GetPrivacyPolicy',{  }, showSpinner);

                    }
    

            getTermsAndConditions(showSpinner = true): Promise<OM.Attachment> {
                        return CommonServices.defaultGet<OM.Attachment>(apiurl + 'api/AppConfiguration/GetTermsAndConditions',{  }, showSpinner);

                    }
    

            uploadPrivacy(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/AppConfiguration/UploadPrivacy', vm, undefined, showSpinner);
            }
    

            uploadTerms(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/AppConfiguration/UploadTerms', vm, undefined, showSpinner);
            }
    }

export let AppConfigurationClient = new _AppConfigurationClient();

class _CommessaClient {

    

            save(
                item:OM.Commessa,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Commessa/Save', item,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.Commessa[]> {
                        return CommonServices.defaultGet<OM.Commessa[]>(apiurl + 'api/Commessa/GetAll',{  }, showSpinner);

                    }
    

            getAvailableAllowancesForCommessa(
                commessaIdentifier:string,showSpinner = true): Promise<OM.CommessaAvailableAllowances> {
                        return CommonServices.defaultGet<OM.CommessaAvailableAllowances>(apiurl + 'api/Commessa/GetAvailableAllowancesForCommessa',{ commessaIdentifier }, showSpinner);

                    }
    

            getCommessaOwnerUsername(
                commessaIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Commessa/GetCommessaOwnerUsername',{ commessaIdentifier }, showSpinner);

                    }
    

            getAllAsNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/Commessa/GetAllAsNameIdentifier',{  }, showSpinner);

                    }
    

            canCreateNewCommessa(showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Commessa/CanCreateNewCommessa',{  }, showSpinner);

                    }
    

            getEnabledParticipatedByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.CommessaSummaryVm[]> {
                        return CommonServices.defaultGet<OM.CommessaSummaryVm[]>(apiurl + 'api/Commessa/GetEnabledParticipatedByUser',{ userIdentifier }, showSpinner);

                    }
    

            getOwnedByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.CommessaSummaryVm[]> {
                        return CommonServices.defaultGet<OM.CommessaSummaryVm[]>(apiurl + 'api/Commessa/GetOwnedByUser',{ userIdentifier }, showSpinner);

                    }
    

            getRoleInCommessa(
                userIdentifier:string,
                commessaIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Commessa/GetRoleInCommessa',{ userIdentifier, commessaIdentifier }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.Commessa> {
                        return CommonServices.defaultGet<OM.Commessa>(apiurl + 'api/Commessa/GetById',{ identifier }, showSpinner);

                    }
    

            getAllowancesOfCommessa(
                identifier:string,showSpinner = true): Promise<OM.CommessaAvailableAllowances> {
                        return CommonServices.defaultGet<OM.CommessaAvailableAllowances>(apiurl + 'api/Commessa/GetAllowancesOfCommessa',{ identifier }, showSpinner);

                    }
    

            checkNameExisting(
                name:string,
                ownerIdentifier:string,
                identifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Commessa/CheckNameExisting',{ name, ownerIdentifier, identifier }, showSpinner);

                    }
    

            toggleEnabled(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Commessa/ToggleEnabled',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Commessa/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let CommessaClient = new _CommessaClient();

class _ExcelQrMappingClient {

    

            save(
                item:OM.ExcelQrMapping,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ExcelQrMapping/Save', item,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.ExcelQrMapping[]> {
                        return CommonServices.defaultGet<OM.ExcelQrMapping[]>(apiurl + 'api/ExcelQrMapping/GetAll',{  }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.ExcelQrMapping> {
                        return CommonServices.defaultGet<OM.ExcelQrMapping>(apiurl + 'api/ExcelQrMapping/GetById',{ identifier }, showSpinner);

                    }
    

            getQrConfigFields(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ExcelQrMapping/GetQrConfigFields',{  }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ExcelQrMapping/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let ExcelQrMappingClient = new _ExcelQrMappingClient();

class _GooglePlacesClient {

    

            autocomplete(
                input:string,showSpinner = true): Promise<OM.PlacePredictionVm[]> {
                        return CommonServices.defaultGet<OM.PlacePredictionVm[]>(apiurl + 'api/GooglePlaces/Autocomplete',{ input }, showSpinner);

                    }
    

            placeDetails(
                placeId:string,showSpinner = true): Promise<OM.Address> {
                        return CommonServices.defaultGet<OM.Address>(apiurl + 'api/GooglePlaces/PlaceDetails',{ placeId }, showSpinner);

                    }
    }

export let GooglePlacesClient = new _GooglePlacesClient();

class _LoginClient {

    

            loginByQrPrintRequestToken(
                commessaIdentifier:string,
                token:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/LoginByQrPrintRequestToken',{ commessaIdentifier, token }, showSpinner);

                    }
    

            register(
                vm:OM.LoginVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Login/Register', vm,{}, showSpinner );

                    }
    

            sendConfirmRegistrationAgain(
                vm:OM.LoginVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Login/SendConfirmRegistrationAgain', vm,{}, showSpinner );

                    }
    

            checkUsernameExisting(
                username:string,
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Login/CheckUsernameExisting',{ username, userIdentifier }, showSpinner);

                    }
    

            completeRegistration(
                confirmationCode:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/CompleteRegistration',{ confirmationCode }, showSpinner);

                    }
    

            login(
                vm:OM.LoginVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Login/Login', vm,{}, showSpinner );

                    }
    

            selectCommessa(
                commessaIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/SelectCommessa',{ commessaIdentifier }, showSpinner);

                    }
    

            refreshLogin(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    

            impersonateUser(
                userIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/ImpersonateUser',{ userIdentifier }, showSpinner);

                    }
    

            requestResetPassword(
                userEmail:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/RequestResetPassword',{ userEmail }, showSpinner);

                    }
    

            resetPassword(
                vm:OM.ResetPasswordVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Login/ResetPassword', vm,{}, showSpinner );

                    }
    }

export let LoginClient = new _LoginClient();

class _MailEventClient {

    

            getMailEvents(showSpinner = true): Promise<OM.MailEventDefinitionWithDesc[]> {
                        return CommonServices.defaultGet<OM.MailEventDefinitionWithDesc[]>(apiurl + 'api/MailEvent/GetMailEvents',{  }, showSpinner);

                    }
    

            getByName(
                name:string,showSpinner = true): Promise<OM.MailEventDefinitionWithDesc> {
                        return CommonServices.defaultGet<OM.MailEventDefinitionWithDesc>(apiurl + 'api/MailEvent/GetByName',{ name }, showSpinner);

                    }
    }

export let MailEventClient = new _MailEventClient();

class _OrderApprovalRequestClient {

    

            getByCommessa(
                commessaIdentifier:string,showSpinner = true): Promise<OM.OrderApprovalRequest[]> {
                        return CommonServices.defaultGet<OM.OrderApprovalRequest[]>(apiurl + 'api/OrderApprovalRequest/GetByCommessa',{ commessaIdentifier }, showSpinner);

                    }
    

            getByOrderIdentifier(
                orderIdentifier:string,showSpinner = true): Promise<OM.OrderApprovalRequest> {
                        return CommonServices.defaultGet<OM.OrderApprovalRequest>(apiurl + 'api/OrderApprovalRequest/GetByOrderIdentifier',{ orderIdentifier }, showSpinner);

                    }
    

            processAndSendOrder(
                vm:OM.ProcessOrderRequestVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/OrderApprovalRequest/ProcessAndSendOrder', vm,{}, showSpinner );

                    }
    }

export let OrderApprovalRequestClient = new _OrderApprovalRequestClient();

class _PdfInterpolationClient {

    

            save(
                document:OM.PdfInterpolationDocument,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PdfInterpolation/Save', document,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.PdfInterpolationDocument[]> {
                        return CommonServices.defaultGet<OM.PdfInterpolationDocument[]>(apiurl + 'api/PdfInterpolation/GetAll',{  }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.PdfInterpolationDocument> {
                        return CommonServices.defaultGet<OM.PdfInterpolationDocument>(apiurl + 'api/PdfInterpolation/GetById',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolation/DeleteById',{ identifier }, showSpinner);

                    }
    

            toggleActive(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolation/ToggleActive',{ identifier }, showSpinner);

                    }
    }

export let PdfInterpolationClient = new _PdfInterpolationClient();

class _PrintTemplateClient {

    

            save(
                item:OM.PrintTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PrintTemplate/Save', item,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.PrintTemplate[]> {
                        return CommonServices.defaultGet<OM.PrintTemplate[]>(apiurl + 'api/PrintTemplate/GetAll',{  }, showSpinner);

                    }
    

            getAllActive(showSpinner = true): Promise<OM.PrintTemplate[]> {
                        return CommonServices.defaultGet<OM.PrintTemplate[]>(apiurl + 'api/PrintTemplate/GetAllActive',{  }, showSpinner);

                    }
    

            getAsNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/PrintTemplate/GetAsNameIdentifierList',{  }, showSpinner);

                    }
    

            getByFilter(
                vm:OM.PrintTemplateListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPrintTemplate> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPrintTemplate>(apiurl + 'api/PrintTemplate/GetByFilter', vm,{}, showSpinner );

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.PrintTemplate> {
                        return CommonServices.defaultGet<OM.PrintTemplate>(apiurl + 'api/PrintTemplate/GetById',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PrintTemplate/DeleteById',{ identifier }, showSpinner);

                    }
    

            checkNameExisting(
                name:string,
                identifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/PrintTemplate/CheckNameExisting',{ name, identifier }, showSpinner);

                    }
    

            toggleActive(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PrintTemplate/ToggleActive',{ identifier }, showSpinner);

                    }
    }

export let PrintTemplateClient = new _PrintTemplateClient();

class _ProgramSubscriptionClient {

    

            getActiveOrLastForUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ProgramSubscriptionDetailVm> {
                        return CommonServices.defaultGet<OM.ProgramSubscriptionDetailVm>(apiurl + 'api/ProgramSubscription/GetActiveOrLastForUser',{ userIdentifier }, showSpinner);

                    }
    

            generateContractForSubscription(
                subscriptionIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProgramSubscription/GenerateContractForSubscription',{ subscriptionIdentifier }, showSpinner);

                    }
    

            sendActivationRequest(
                userIdentifier:string,
                planType:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProgramSubscription/SendActivationRequest',{ userIdentifier, planType }, showSpinner);

                    }
    

            isActiveForCurrentUser(showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ProgramSubscription/IsActiveForCurrentUser',{  }, showSpinner);

                    }
    

            activateTrial(
                userIdentifier:string,showSpinner = true): Promise<OM.ProgramSubscription> {
                        return CommonServices.defaultGet<OM.ProgramSubscription>(apiurl + 'api/ProgramSubscription/ActivateTrial',{ userIdentifier }, showSpinner);

                    }
    

            save(
                item:OM.ProgramSubscription,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ProgramSubscription/Save', item,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.ProgramSubscription[]> {
                        return CommonServices.defaultGet<OM.ProgramSubscription[]>(apiurl + 'api/ProgramSubscription/GetAll',{  }, showSpinner);

                    }
    

            getActiveAllowancesByOwner(
                ownerIdentifier:string,showSpinner = true): Promise<OM.Allowances> {
                        return CommonServices.defaultGet<OM.Allowances>(apiurl + 'api/ProgramSubscription/GetActiveAllowancesByOwner',{ ownerIdentifier }, showSpinner);

                    }
    

            getByOwner(
                ownerIdentifier:string,showSpinner = true): Promise<OM.ProgramSubscription[]> {
                        return CommonServices.defaultGet<OM.ProgramSubscription[]>(apiurl + 'api/ProgramSubscription/GetByOwner',{ ownerIdentifier }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.ProgramSubscription> {
                        return CommonServices.defaultGet<OM.ProgramSubscription>(apiurl + 'api/ProgramSubscription/GetById',{ identifier }, showSpinner);

                    }
    

            uploadAttachment(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/ProgramSubscription/UploadAttachment', vm, undefined, showSpinner);
            }
    

            deleteAttachment(
                subscriptionIdentifier:string,
                attachmentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProgramSubscription/DeleteAttachment',{ subscriptionIdentifier, attachmentIdentifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProgramSubscription/DeleteById',{ identifier }, showSpinner);

                    }
    

            sendConfermaAttivazioneLicenza(
                identifier:string,
                email:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProgramSubscription/SendConfermaAttivazioneLicenza',{ identifier, email }, showSpinner);

                    }
    

            isActive(
                ownerIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ProgramSubscription/IsActive',{ ownerIdentifier }, showSpinner);

                    }
    

            saveComment(
                vm:OM.SaveCommentVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(apiurl + 'api/ProgramSubscription/SaveComment', vm,{}, showSpinner );

                    }
    

            deleteComment(
                programSubscriptionIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ProgramSubscription/DeleteComment',{ programSubscriptionIdentifier, commentIdentifier }, showSpinner);

                    }
    }

export let ProgramSubscriptionClient = new _ProgramSubscriptionClient();

class _QrConfigClient {

    

            checkMaxQrReached(showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/QrConfig/CheckMaxQrReached',{  }, showSpinner);

                    }
    

            save(
                item:OM.QrConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/QrConfig/Save', item,{}, showSpinner );

                    }
    

            create(
                item:OM.QrConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/QrConfig/Create', item,{}, showSpinner );

                    }
    

            getByFilter(
                vm:OM.QrConfigListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfQrConfig> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfQrConfig>(apiurl + 'api/QrConfig/GetByFilter', vm,{}, showSpinner );

                    }
    

            selectAllExisting(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/QrConfig/SelectAllExisting',{  }, showSpinner);

                    }
    

            getQrConfigWithTemplates(
                identifiers:string[],showSpinner = true): Promise<OM.QrConfig[]> {
                        return CommonServices.defaultPost<OM.QrConfig[]>(apiurl + 'api/QrConfig/GetQrConfigWithTemplates', identifiers,{}, showSpinner );

                    }
    

            getQrUsageCounter(
                commessaIdentifier:string,showSpinner = true): Promise<OM.QrUsageCounterVm> {
                        return CommonServices.defaultGet<OM.QrUsageCounterVm>(apiurl + 'api/QrConfig/GetQrUsageCounter',{ commessaIdentifier }, showSpinner);

                    }
    

            getAsNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/QrConfig/GetAsNameIdentifierList',{  }, showSpinner);

                    }
    

            getForOrderList(showSpinner = true): Promise<OM.QrConfigForOrderVm[]> {
                        return CommonServices.defaultGet<OM.QrConfigForOrderVm[]>(apiurl + 'api/QrConfig/GetForOrderList',{  }, showSpinner);

                    }
    

            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/QrConfig/ExportExcel',{  }, showSpinner);

                    }
    

            exportExcelByList(
                ids:string[],showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/QrConfig/ExportExcelByList', ids,{}, showSpinner );

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.QrConfig> {
                        return CommonServices.defaultGet<OM.QrConfig>(apiurl + 'api/QrConfig/GetById',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/QrConfig/DeleteById',{ identifier }, showSpinner);

                    }
    

            deleteMultipleById(
                identifierList:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/QrConfig/DeleteMultipleById', identifierList,{}, showSpinner );

                    }
    

            checkNameExisting(
                name:string,
                identifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/QrConfig/CheckNameExisting',{ name, identifier }, showSpinner);

                    }
    

            toggleEnabled(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/QrConfig/ToggleEnabled',{ identifier }, showSpinner);

                    }
    }

export let QrConfigClient = new _QrConfigClient();

class _QrPrintRequestClient {

    

            getByToken(
                token:string,showSpinner = true): Promise<OM.QrPrintRequest> {
                        return CommonServices.defaultGet<OM.QrPrintRequest>(apiurl + 'api/QrPrintRequest/GetByToken',{ token }, showSpinner);

                    }
    

            getActiveRequest(showSpinner = true): Promise<OM.QrPrintProgressVm> {
                        return CommonServices.defaultGet<OM.QrPrintProgressVm>(apiurl + 'api/QrPrintRequest/GetActiveRequest',{  }, showSpinner);

                    }
    

            getProgress(
                identifier:string,showSpinner = true): Promise<OM.QrPrintProgressVm> {
                        return CommonServices.defaultGet<OM.QrPrintProgressVm>(apiurl + 'api/QrPrintRequest/GetProgress',{ identifier }, showSpinner);

                    }
    }

export let QrPrintRequestClient = new _QrPrintRequestClient();

class _RegisterInvitationClient {

    

            sendInvitationToRegisterInCommessa(
                vm:OM.SendRegisterInvitationVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/RegisterInvitation/SendInvitationToRegisterInCommessa', vm,{}, showSpinner );

                    }
    

            removeInvitation(
                invitationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/RegisterInvitation/RemoveInvitation',{ invitationIdentifier }, showSpinner);

                    }
    

            sendAgain(
                invitationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/RegisterInvitation/SendAgain',{ invitationIdentifier }, showSpinner);

                    }
    

            getByToken(
                token:string,showSpinner = true): Promise<OM.RegisterInvitation> {
                        return CommonServices.defaultGet<OM.RegisterInvitation>(apiurl + 'api/RegisterInvitation/GetByToken',{ token }, showSpinner);

                    }
    

            getByCommessa(
                commessaIdentifier:string,showSpinner = true): Promise<OM.RegisterInvitation[]> {
                        return CommonServices.defaultGet<OM.RegisterInvitation[]>(apiurl + 'api/RegisterInvitation/GetByCommessa',{ commessaIdentifier }, showSpinner);

                    }
    

            acceptRegisterInvitation(
                registerInvitationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/RegisterInvitation/AcceptRegisterInvitation',{ registerInvitationIdentifier }, showSpinner);

                    }
    

            completeRegisterInvitation(
                vm:OM.CompleteRegisterInvitationVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/RegisterInvitation/CompleteRegisterInvitation', vm,{}, showSpinner );

                    }
    }

export let RegisterInvitationClient = new _RegisterInvitationClient();

class _ScanQrClient {

    

            getQrAuthType(
                qrIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ScanQr/GetQrAuthType',{ qrIdentifier }, showSpinner);

                    }
    

            qrAuth(
                vm:OM.QrAuthVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ScanQr/QrAuth', vm,{}, showSpinner );

                    }
    

            qrAuthLogin(
                vm:OM.QrAuthLoginVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ScanQr/QrAuthLogin', vm,{}, showSpinner );

                    }
    

            qrAuthAutoLogin(
                qrIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ScanQr/QrAuthAutoLogin',{ qrIdentifier }, showSpinner);

                    }
    }

export let ScanQrClient = new _ScanQrClient();

class _ShopCategoryConfigClient {

    

            save(
                item:OM.ShopCategoryConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopCategoryConfig/Save', item,{}, showSpinner );

                    }
    

            getAll(showSpinner = true): Promise<OM.ShopCategoryConfig[]> {
                        return CommonServices.defaultGet<OM.ShopCategoryConfig[]>(apiurl + 'api/ShopCategoryConfig/GetAll',{  }, showSpinner);

                    }
    

            getAllAsNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopCategoryConfig/GetAllAsNameIdentifierList',{  }, showSpinner);

                    }
    

            uploadImage(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/ShopCategoryConfig/UploadImage', vm, undefined, showSpinner);
            }
    

            deleteImage(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopCategoryConfig/DeleteImage',{ identifier }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopCategoryConfig> {
                        return CommonServices.defaultGet<OM.ShopCategoryConfig>(apiurl + 'api/ShopCategoryConfig/GetById',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopCategoryConfig/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let ShopCategoryConfigClient = new _ShopCategoryConfigClient();

class _ShopOrderClient {

    

            save(
                item:OM.ShopOrder,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopOrder/Save', item,{}, showSpinner );

                    }
    

            newOrder(
                commessaIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ShopOrder/NewOrder',{ commessaIdentifier }, showSpinner);

                    }
    

            getOpenDraft(showSpinner = true): Promise<OM.ShopOrder> {
                        return CommonServices.defaultGet<OM.ShopOrder>(apiurl + 'api/ShopOrder/GetOpenDraft',{  }, showSpinner);

                    }
    

            addProductToOrder(
                vm:OM.AddProductToOrderVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopOrder/AddProductToOrder', vm,{}, showSpinner );

                    }
    

            countOrdersWaiting(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/ShopOrder/CountOrdersWaiting',{  }, showSpinner);

                    }
    

            getAll(showSpinner = true): Promise<OM.ShopOrder[]> {
                        return CommonServices.defaultGet<OM.ShopOrder[]>(apiurl + 'api/ShopOrder/GetAll',{  }, showSpinner);

                    }
    

            getByFilter(
                vm:OM.ShopOrderListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfShopOrderForListVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfShopOrderForListVm>(apiurl + 'api/ShopOrder/GetByFilter', vm,{}, showSpinner );

                    }
    

            getByCommessa(
                commessaIdentifier:string,showSpinner = true): Promise<OM.ShopOrder[]> {
                        return CommonServices.defaultGet<OM.ShopOrder[]>(apiurl + 'api/ShopOrder/GetByCommessa',{ commessaIdentifier }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopOrder> {
                        return CommonServices.defaultGet<OM.ShopOrder>(apiurl + 'api/ShopOrder/GetById',{ identifier }, showSpinner);

                    }
    

            submitOrderByEditor(
                vm:OM.SubmitOrderVm,showSpinner = true): Promise<OM.ShopOrder> {
                        return CommonServices.defaultPost<OM.ShopOrder>(apiurl + 'api/ShopOrder/SubmitOrderByEditor', vm,{}, showSpinner );

                    }
    

            submitOrderByAdmin(
                vm:OM.SubmitOrderVm,showSpinner = true): Promise<OM.ShopOrder> {
                        return CommonServices.defaultPost<OM.ShopOrder>(apiurl + 'api/ShopOrder/SubmitOrderByAdmin', vm,{}, showSpinner );

                    }
    

            updateStatus(
                identifier:string,
                status:string,
                notes:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOrder/UpdateStatus',{ identifier, status, notes }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOrder/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let ShopOrderClient = new _ShopOrderClient();

class _ShopProductClient {

    

            getAll(showSpinner = true): Promise<OM.ShopProduct[]> {
                        return CommonServices.defaultGet<OM.ShopProduct[]>(apiurl + 'api/ShopProduct/GetAll',{  }, showSpinner);

                    }
    

            getByCategory(
                categoryIdentifier:string,showSpinner = true): Promise<OM.ShopProduct[]> {
                        return CommonServices.defaultGet<OM.ShopProduct[]>(apiurl + 'api/ShopProduct/GetByCategory',{ categoryIdentifier }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopProduct> {
                        return CommonServices.defaultGet<OM.ShopProduct>(apiurl + 'api/ShopProduct/GetById',{ identifier }, showSpinner);

                    }
    

            save(
                item:OM.ShopProduct,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopProduct/Save', item,{}, showSpinner );

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopProduct/DeleteById',{ identifier }, showSpinner);

                    }
    

            uploadImage(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/ShopProduct/UploadImage', vm, undefined, showSpinner);
            }
    

            uploadTechnicalSheet(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/ShopProduct/UploadTechnicalSheet', vm, undefined, showSpinner);
            }
    

            deleteImage(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopProduct/DeleteImage',{ identifier }, showSpinner);

                    }
    

            deleteTechnicalSheet(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopProduct/DeleteTechnicalSheet',{ identifier }, showSpinner);

                    }
    }

export let ShopProductClient = new _ShopProductClient();

class _SubscriptionTypeClient {

    

            getAll(showSpinner = true): Promise<OM.SubscriptionType[]> {
                        return CommonServices.defaultGet<OM.SubscriptionType[]>(apiurl + 'api/SubscriptionType/GetAll',{  }, showSpinner);

                    }
    

            getForDisplay(showSpinner = true): Promise<OM.SubscriptionType[]> {
                        return CommonServices.defaultGet<OM.SubscriptionType[]>(apiurl + 'api/SubscriptionType/GetForDisplay',{  }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.SubscriptionType> {
                        return CommonServices.defaultGet<OM.SubscriptionType>(apiurl + 'api/SubscriptionType/GetById',{ identifier }, showSpinner);

                    }
    

            save(
                item:OM.SubscriptionType,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SubscriptionType/Save', item,{}, showSpinner );

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SubscriptionType/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let SubscriptionTypeClient = new _SubscriptionTypeClient();

class _UploadClient {

    

            uploadFile(vm: any, showSpinner = true): Promise<OM.Attachment> {
                return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + 'api/Upload/UploadFile', vm, undefined, showSpinner);
            }
    

            uploadComment(vm: any, showSpinner = true): Promise<OM.Comment> {
                return CommonServices.uploadFileToUrl<OM.Comment>(apiurl + 'api/Upload/UploadComment', vm, undefined, showSpinner);
            }
    }

export let UploadClient = new _UploadClient();

class _UserClient {

    

            save(
                item:OM.User,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/User/Save', item,{}, showSpinner );

                    }
    

            createUser(
                item:OM.User,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/User/CreateUser', item,{}, showSpinner );

                    }
    

            getByFilter(
                vm:OM.UserListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfUserForListVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfUserForListVm>(apiurl + 'api/User/GetByFilter', vm,{}, showSpinner );

                    }
    

            getByCompany(showSpinner = true): Promise<OM.User[]> {
                        return CommonServices.defaultGet<OM.User[]>(apiurl + 'api/User/GetByCompany',{  }, showSpinner);

                    }
    

            getNameIdentifier(
                identifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/User/GetNameIdentifier',{ identifier }, showSpinner);

                    }
    

            oblivion(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/User/Oblivion',{ userIdentifier }, showSpinner);

                    }
    

            searchUser(
                search:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/User/SearchUser',{ search }, showSpinner);

                    }
    

            getAllAsNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/User/GetAllAsNameIdentifierList',{  }, showSpinner);

                    }
    

            getSelf(showSpinner = true): Promise<OM.User> {
                        return CommonServices.defaultGet<OM.User>(apiurl + 'api/User/GetSelf',{  }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.User> {
                        return CommonServices.defaultGet<OM.User>(apiurl + 'api/User/GetById',{ identifier }, showSpinner);

                    }
    

            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/User/DeleteById',{ identifier }, showSpinner);

                    }
    

            setPassword(
                identifier:string,
                password:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/User/SetPassword',{ identifier, password }, showSpinner);

                    }
    

            sendHelpRequest(
                identifier:string,
                text:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/User/SendHelpRequest',{ identifier, text }, showSpinner);

                    }
    }

export let UserClient = new _UserClient();

class _InterpolationTemplateClient {

    

            getAll(showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetAll',{  }, showSpinner);

                    }
    

            getByEventName(
                eventName:string,showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetByEventName',{ eventName }, showSpinner);

                    }
    

            getById(
                identifier:string,showSpinner = true): Promise<OM.InterpolationTemplate> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate>(apiurl + 'api/InterpolationTemplate/GetById',{ identifier }, showSpinner);

                    }
    

            save(
                item:OM.InterpolationTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/InterpolationTemplate/Save', item,{}, showSpinner );

                    }
    

            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InterpolationTemplate/Delete',{ identifier }, showSpinner);

                    }
    }

export let InterpolationTemplateClient = new _InterpolationTemplateClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}